import { render, staticRenderFns } from "./profileCreateAccount.vue?vue&type=template&id=d487353e&"
import script from "./profileCreateAccount.vue?vue&type=script&lang=js&"
export * from "./profileCreateAccount.vue?vue&type=script&lang=js&"
import style0 from "./profileCreateAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports